import PageLoading, { type PageLoadingVariant } from '@/shared/ui/page-loading'
import RouteErrorPage from '@/shared/ui/route-error-page'

import { ROUTER } from '@/shared/config'
import React from 'react'
import { type RouteObject, createBrowserRouter } from 'react-router-dom'
import { adminRoutes } from './components/adminRoutes'
import { publicRoutes } from './components/publicRoutes'
import { userRoutes } from './components/userRoutes'

// common
const PublicRouters = React.lazy(() => import('@/app/routes/guards/PublicRouters'))
const PrivateRoutes = React.lazy(() => import('@/app/routes/guards/PrivateRoutes'))

const SvgViewer = React.lazy(() => import('@/pages/dev-tools/SvgViewer'))
const DesignSystemPage = React.lazy(() => import('@/pages/dev-tools'))
const NotFound = React.lazy(() => import('@/pages/not-found'))

// Ideally this would be an API call to server to get logged in user data
// const getUserData = () => {};

export function LazyLoadingComponent({
  variant,
  children,
}: {
  variant: PageLoadingVariant
  children: React.ReactNode
}) {
  return (
    <React.Suspense fallback={<PageLoading fullscreen variant={variant} />}>
      {children}
    </React.Suspense>
  )
}
const routes: RouteObject[] = [
  {
    errorElement: <RouteErrorPage />,
    children: [
      ...(import.meta.env.DEV
        ? [
            {
              path: ROUTER.DESIGN_SYSTEM,
              element: (
                <LazyLoadingComponent variant="public">
                  <DesignSystemPage />
                </LazyLoadingComponent>
              ),
            },
          ]
        : []),
      {
        path: ROUTER.SVG_VIEWER,
        element: (
          <LazyLoadingComponent variant="public">
            <SvgViewer />
          </LazyLoadingComponent>
        ),
      },
      // ADMIN
      ...adminRoutes,
      //  USER
      {
        element: (
          <LazyLoadingComponent variant="private">
            <PrivateRoutes />
          </LazyLoadingComponent>
        ),
        children: [...userRoutes],
      },
      //  ANONYMOUS
      {
        element: (
          <LazyLoadingComponent variant="public">
            <PublicRouters />
          </LazyLoadingComponent>
        ),
        //  loader: () => defer({ userPromise: getUserData() }),
        children: [...publicRoutes],
      },
      {
        path: '*',
        element: (
          <LazyLoadingComponent variant="public">
            <NotFound />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
]

export const router = createBrowserRouter(routes)
